import React from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/containers/shared/Layout';

const SignupContainer = props => {
  return (
    <Layout title="Welcome to The Mom Project" className="mb-5">
      <div
        className="grow-in-column"
        css={({ theme }) => `background-color: ${theme.lightBlue};`}
      >
        <div className="mb-5 pt-5"></div>
        {props.children}
        <div className="mt-5 pb-5"></div>
      </div>
    </Layout>
  );
};
SignupContainer.propTypes = {
  children: PropTypes.any,
};
export default SignupContainer;
